import { render, staticRenderFns } from "./SurveyPresent.vue?vue&type=template&id=69462dc2&"
import script from "./SurveyPresent.vue?vue&type=script&lang=ts&"
export * from "./SurveyPresent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports